import React from "react";
import { Box, Container } from "@mui/material";
import Hero from "./Hero";
import BookingPipeline from "./BookingPipeline";
import FeatureHighlight from "./FeatureHighlight";
import CTA from "./CTA";

export default function LandingPage(): React.ReactElement {
  return (
    <Container sx={{ py: { xs: 4, md: 8 } }}>
      <Hero />
      <BookingPipeline />
      <FeatureHighlight />
      <Box sx={{ py: { xs: 2, md: 4 } }}>
        <CTA />
      </Box>
    </Container>
  );
}
